var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoExperiments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "90px",
    viewBox: "0 0 147 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PageComponent/States/NonExistingExperiment",
    transform: "translate(-154.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty",
    transform: "translate(154.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-44-Copy-+-Rectangle-44-Copy-Copy",
    transform: "translate(30.000000, 14.000000)",
    stroke: "#43C8EC",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.741609,7 L15.8351259,-0.756037119 C16.3298711,-1.5093991 17.241332,-2 18.1439612,-2 L43.5873821,-2 C44.4210332,-2 45.2931545,-1.58401333 45.8168185,-0.931597206 L52.183142,7 L85.5155434,7 C87.9917944,7 90,9.01519262 90,11.4890789 L90,69.5109211 C90,71.9913496 87.9907454,74 85.5080838,74 L2.49191622,74 C0.012896518,74 -2,71.9861467 -2,69.5109211 L-2,11.4890789 C-2,9.00837311 0.00896797934,7 2.49246368,7 L10.741609,7 Z",
    id: "Rectangle-44-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2,20.6666667 L90,20.6666667 L90,69.5197435 C90,71.9968892 87.9891593,74 85.5080838,74 L2.49191622,74 C0.0159958538,74 -2,71.9863744 -2,69.5197435 L-2,20.6666667 Z",
    id: "Rectangle-44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.953358,7.79357798 C132.953358,6.25072746 131.698196,5 130.149876,5 C128.601555,5 127.346393,6.25072746 127.346393,7.79357798 C127.346393,9.3364285 128.601555,10.587156 130.149876,10.587156 C131.698196,10.587156 132.953358,9.3364285 132.953358,7.79357798 Z M128.147388,7.79357798 C128.147388,6.6915419 129.043932,5.79816514 130.149876,5.79816514 C131.255819,5.79816514 132.152363,6.6915419 132.152363,7.79357798 C132.152363,8.89561406 131.255819,9.78899083 130.149876,9.78899083 C129.043932,9.78899083 128.147388,8.89561406 128.147388,7.79357798 Z",
    id: "Oval-4-Copy",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.507463,33.7889908 L139.507463,30.7789335 C139.507463,29.9519393 140.17326,29.2815281 141.007463,29.2815281 C141.83589,29.2815281 142.507463,29.9619278 142.507463,30.7789335 L142.507463,33.7889908 L145.51752,33.7889908 C146.344514,33.7889908 147.014925,34.4547881 147.014925,35.2889908 C147.014925,36.117418 146.334526,36.7889908 145.51752,36.7889908 L142.507463,36.7889908 L142.507463,39.7990482 C142.507463,40.6260423 141.841665,41.2964535 141.007463,41.2964535 C140.179036,41.2964535 139.507463,40.6160538 139.507463,39.7990482 L139.507463,36.7889908 L136.497405,36.7889908 C135.670411,36.7889908 135,36.1231936 135,35.2889908 C135,34.4605637 135.6804,33.7889908 136.497405,33.7889908 L139.507463,33.7889908 Z",
    id: "Combined-Shape",
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fast_computer_chip",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,3.12 C25,4.84312842 26.3968716,6.24 28.12,6.24 C29.8431284,6.24 31.24,4.84312842 31.24,3.12 C31.24,1.39687158 29.8431284,0 28.12,0 C27.2925246,-3.55271368e-15 26.4989403,0.328713342 25.9138268,0.913826843 C25.3287133,1.49894034 25,2.29252455 25,3.12 Z M29.24,3.12 C29.24,3.73855892 28.7385589,4.24 28.12,4.24 C27.5014411,4.24 27,3.73855892 27,3.12 C27,2.50144108 27.5014411,2 28.12,2 C28.7307345,2.0109077 29.2200974,2.50916813 29.22,3.12 L29.24,3.12 Z",
    id: "Shape",
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12,20.83 L12.12,18.3 C9.70651564,18.3 7.75,16.3434844 7.75,13.93 L5.32,13.93 C5.32,16.3434844 3.36348436,18.3 0.95,18.3 L0.95,20.83 C3.36348436,20.83 5.32,22.7865156 5.32,25.2 L7.75,25.2 C7.75,22.7865156 9.70651564,20.83 12.12,20.83 Z M6.53,22.14 C5.92469267,21.0411659 5.01024881,20.1441069 3.9,19.56 C5.00744891,18.9812516 5.92159416,18.0914372 6.53,17 C7.13530733,18.0988341 8.04975119,18.9958931 9.16,19.58 C8.05255109,20.1587484 7.13840584,21.0485628 6.53,22.14 Z",
    id: "Shape",
    fill: "#10B36B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoExperiments);
export default __webpack_public_path__ + "static/media/no-experiments.0e4f4a114ef73e7d81c09474aba64b6c.svg";
export { ForwardRef as ReactComponent };